export const TIPTAP_ENDPOINTS = {
   GET_TOKEN: () => '/tiptap/token',
};
